<template>
  <div class="login">
    <div class="background" v-if="!!code" v-loading.fullscreen.lock="fullscreenLoading"></div>
    <div class="content" v-else>
      <!-- <img src="@/assets/images/5.png" alt="" class="login-logo" /> -->
      <div class="login-logo">协同&emsp;适配&emsp;便利&emsp;敏捷</div>
      <div class="login-rt">

        <div class="login-rt-content">
           <div style="display:flex;margin-top:20px;">
              <img src="@/assets/img/logo.png" alt="" style="height:60px;width:60px;border-radius:50%;border:1px solid #e2eeff;" />
              <div class="content-title" style="margin-left:15px;">好运来管理后台</div>
            </div>
          <el-form style="margin-top:30px;" :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">

            <!-- <div class="content-title1">Terminal Management System</div> -->
            <el-form-item v-if="form.pwdLogin === true" prop="account">
              <el-input v-model.trim="form.account" clearable placeholder="请输入登录名" auto-complete="new-phone">
                <i slot="prefix" style="font-size: 25px; color: #888" class="el-input__icon el-icon-user-solid"></i
              ></el-input>
            </el-form-item>
            <el-form-item v-if="form.pwdLogin === false" prop="phone">
              <el-input v-model.trim="form.phone" clearable placeholder="请输入手机号" auto-complete="new-phone">
                <i slot="prefix" style="font-size: 25px; color: #888" class="el-input__icon el-icon-user-solid"></i>
                <!-- <template slot="append"></template> -->
              </el-input>
              <el-link
                :disabled="sendCode"
                style="width: 70px; position: absolute; margin-top: 5px; z-index: 999; right: 30px; color: #247eff"
                :underline="false"
                @click="getPhoneCode"
                >{{ codeTxt }}</el-link
              >
            </el-form-item>
            <el-form-item v-if="form.pwdLogin === false" prop="code">
              <el-input v-model.trim="form.code" clearable placeholder="请输入短信验证码" auto-complete="new-phone">
                <i slot="prefix" style="font-size: 25px; color: #888" class="el-input__icon el-icon-chat-dot-square"></i
              ></el-input>
            </el-form-item>
            <el-form-item v-if="form.pwdLogin === true" prop="passWord">
              <el-input
                v-model.trim="form.password"
                show-password
                placeholder="请输入密码"
                clearable
                auto-complete="new-password"
                @keyup.enter.native="submit"
              >
                <i slot="prefix" style="font-size: 25px; color: #888" class="el-input__icon el-icon-lock"></i
              ></el-input>
            </el-form-item>
            <div class="remember-password">
              <el-checkbox v-model="isRememberPassword" @change="setRememberPassword">记住密码</el-checkbox>
              <el-tooltip class="tip" effect="dark" content="非工作电脑请勿保存" placement="right">
                <i class="el-icon-info"></i>
              </el-tooltip>
              <el-link style="margin-left: 15px; color: #247eff"  @click="form.pwdLogin = !form.pwdLogin">切换登陆方式</el-link>
            </div>
          </el-form>
          <el-button type="primary" class="login-btn" :loading="logining" @click="submit" @keyup.enter="submit">登录</el-button>
        </div>
      </div>
    </div>
    <div class="copyright">
      <p>Copyright © 辰凡运输, All Rights Reserved.</p>
      <p>杭州辰凡汽车运输有限公司</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { AES_ECB_ENCRYPT, AES_ECB_DECRYPT } from '@/utils/util.js'
import {  getSmsCode } from '@/api/login.js'

export default {
  layout: 'empty',
  data() {
    const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    const validatPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      logining: false,
      form: {
        account:'',
        phone: '',
        password: '',
        code: '',
        pwdLogin: true //true-手机号密码登陆 false-手机验证码登录
      },
      reg: reg,
      codeTxt: '获取验证码',
      t: 60, //倒计时剩余时间
      sendCode: false, //是否禁用点击获取验证码按钮

      rules: {
        account:[{ required: true, message: '登录名不能为空', trigger: 'blur' }],
        phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }, { validator: validatPhone }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }]
      },
      fullscreenLoading: true,
      code: this.$route.query.code || '',
      isRememberPassword: window.localStorage.getItem('isRememberPassword') === 'true' // 是否记住密码
    }
  },

  computed: {},
  watch: {
    isRememberPassword(newVal) {
      window.localStorage.setItem('isRememberPassword', newVal)
    }
  },

  created() {
    if (window.localStorage.getItem('hyl_admin_user')) {
      const [account, password] = window.localStorage.getItem('hyl_admin_user').split(',')
      this.form.account = account
      this.form.password = AES_ECB_DECRYPT(password, process.env.VUE_APP_SECRET_KEY)
    }
  },
  beforeDestroy() {
    window.localStorage.setItem('isRememberPassword', this.isRememberPassword)
  },

  methods: {
    ...mapActions({
      login: 'login'
      // getLoginToken: 'user/getLoginToken',
      // getUserInfo: 'user/getUserInfoByToken',
    }),
    ...mapMutations({
      setUserInfo: 'SET_USER_INFO'
    }),

    async submit() {
      // 登录

      try {
        await this.$refs.form.validate()
        const res = await this.login(this.form)
        // console.log(res)
        if(res.code!==200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('登录成功！')
        // this.setUserInfo = res.data.baseConsignor

        // window.localStorage.setItem('userInfo', JSON.stringify(res.data.baseConsignor))
        const password = AES_ECB_ENCRYPT(this.form.password, process.env.VUE_APP_SECRET_KEY)
        if (this.isRememberPassword) {
          window.localStorage.setItem('hyl_admin_user',this.form.account + ',' + password)
        } else {
          window.localStorage.setItem('hyl_admin_user', '')
        }
        this.$router.push('/layout/home').catch()
      } catch (err) {
        console.log(err)
      }
    },
    // 记住密码
    setRememberPassword(val) {
      console.log(val)
    },
    // 获取短信验证码
    getPhoneCode() {
      let params = {
        phone: this.form.phone,
        type: 'LOGIN'
      }
      if (!this.reg.test(this.form.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      this.sendCode = true

      this.t = 60 //60s
      let _this = this
      var auth_timetimer = setInterval(() => {
        _this.t--
        _this.codeTxt = _this.t + '秒'
        if (_this.t <= 0) {
          this.sendCode = false
          _this.codeTxt = '获取验证码'
          clearInterval(auth_timetimer)
        }
      }, 1000)
      getSmsCode(params).then(res => {
        if (res.code === 200) {
          this.$message.success('获取验证码成功')
        } else {
          this.$message.error('获取验证码失败')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input-group__append {
  background-color: #ffffff !important;
  border: none;
}
.login {
  width: 100%;
  height: 100%;
  position: relative;
  background: $primary-color;
  .content {
    width: 1000px;
    height: 80%;
    min-height: 400px;
    position: absolute;
    top: 5%;
    // bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    // border-radius: 8px;
    // box-shadow: 0px 2px 20px 0px #e2eeff;
    // background: #ffffff;
    display: flex;

    .login-logo1 {
      height: 20%;
      margin-top: 4%;
      margin-bottom: 2%;
    }

    .login-logo {
      width: 500px;
      height: 500px;
      color: #ffffff;
      font-size: 36px;
      line-height: 500px;
    }

    .login-rt {
      width: 450px;
      height: 80%;
      margin-top:80px;
      position: relative;
      box-shadow: 0px 2px 20px 0px #e2eeff;
      border-radius: 15px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;

      .login-rt-content {
        width: 80%;
        height: 60%;

        ::v-deep .el-form-item {
          display: flex;
          flex-direction: column;
          .el-form-item__content {
            margin-left: 0 !important;
            margin-bottom: 10px;
            .el-input__inner {
              border: none;
              border-bottom: 1px solid #d4d4d4;
              padding-left: 55px;
            }
          }
        }

        .content-title {
          // height: 90px;
          padding-top:10px;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: $primary-color;
          line-height: 8vh;
          text-align: center;
          // margin-bottom: 25px;
          // text-align: center;
          // font-size: 32px;
          // font-weight: 500;
          // color: #2d303b;
          // margin-bottom: 60px;
        }
        .content-title1 {
          // height: 90px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: $primary-color;
          line-height: 5vh;
          margin-bottom: 3vh;
          text-align: center;
          // text-align: center;
          // font-size: 32px;
          // font-weight: 500;
          // color: #2d303b;
          // margin-bottom: 60px;
        }

        .input-style {
          margin-bottom: 40px;

          p {
            color: #2d303b;
          }

          input {
            width: 100%;
            height: 35px;
            line-height: 35px;
            // background: transparent;
            border: none;
            border-bottom: 1px solid #d4d4d4;
          }
        }

        .login-btn {
          width: 100%;
          height: 50px;
          margin-top: 3%;
        }
      }
    }
  }
  .copyright {
    width: 100%;
    height: 8%;
    position: absolute;
    // top: 720px;
    bottom: 4%;
    right: 0;
    left: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      font-size: 12px;
      color: #cccccc;
      margin: 5px;
    }
  }
  .remember-password {
    // position: absolute;
    // left: 0;
    // bottom: 10px;
    display: flex;
    align-items: center;
    .tip {
      margin-left: 10px;
    }
  }
}
</style>
